import { cn } from "@/lib/cn";

const NEQUI_PINK = "#E0007F";

/**
 * Small inline Nequi-flavoured badge. We don't ship Nequi's official
 * artwork (no licensed assets in this repo); this is a brand-pink wordmark
 * + a stylized lightning bolt that visually anchors the customer in the
 * "I'm paying with Nequi" context.
 */
export function NequiBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold",
        className
      )}
      style={{ background: "#FFF1F8", color: NEQUI_PINK }}
    >
      <NequiBolt className="h-3.5 w-3.5" />
      Nequi
    </span>
  );
}

export function NequiBolt({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M13.5 2 5 13.5h6L9.5 22 18 10.5h-6L13.5 2Z"
        fill="currentColor"
      />
    </svg>
  );
}
